import { escape } from 'lodash'
import { type StyledTextDataItem } from '@wix/document-services-types'
import {
  UPLOAD_BUTTON_ROLE,
  IMAGE_ROLE,
} from '@wix/wix-data-client-common-standalone'

import {
  assertNonNullable,
  assertStyledTextData,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const addComponentForImageField: FieldComponentAdder = ({
  fieldKey,
  fieldName,
  page,
  templateComponentByVeloId,
  templateControllerConnectionsByVeloId,
}) =>
  addComponentForField({
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
    templateVeloId: 'imageFieldTemplate',
    componentAdjustments: { veloId: `${fieldKey}Field` },
    subComponentAdjustmentsByVeloId: {
      imageFieldName: {
        modifyComponent: component => {
          assertNonNullable(component.data)
          assertStyledTextData(component.data)
          const data: StyledTextDataItem = {
            ...component.data,
            text: `<p class="font_8">${escape(fieldName)}</p>`,
          }
          return { ...component, data }
        },
        veloId: `${fieldKey}FieldName`,
      },
      imageFieldPreview: {
        connectionConfigModifierByRole: {
          [IMAGE_ROLE]: config =>
            setConnectionConfigPropertyField({
              config,
              propertyName: 'src',
              fieldKey,
            }),
        },
        veloId: `${fieldKey}FieldPreview`,
      },
      imageFieldUploadButton: {
        connectionConfigModifierByRole: {
          [UPLOAD_BUTTON_ROLE]: config =>
            setConnectionConfigPropertyField({
              config,
              propertyName: 'value',
              fieldKey,
            }),
        },
        veloId: `${fieldKey}FieldUploadButton`,
      },
    },
  })
